// Copyright (c) Hamilton Manufacturing Corp.

import { getOS, getSubdomain } from "./components/_common/api/utility";

const initialState = {
    url_key: null,
    app_key: null,
    subdomain: getSubdomain(),
    site_config: {},
    active_user: {
        isLoggedIn: false,
        isGuestUser: false,
        account: {},
        vehicle: null,
        payment: null,
        accessToken: null,
        refreshToken: null,
        washClub: null,
        location: {
            lat: null,
            lng: null
        },
        notifications: {
            unread: 0,
            messages: []
        },
        pastGifts: [],
        forcedLocation: null
    },
    // mobileView: window.innerWidth < 1200,
    OS: getOS(),
    dark_theme: false,
    cart: [],
    discounts: [],
    isLoading: true,
    isOffline: false,
    version: '1.0.4'
};

export const siteConfigVer = '1.1.0'

export default initialState;

export const defaultSiteConfig = {
    has_app: true,
    has_ecom: true,
    themes: {
        light: {
            active: "#f4ea0f",
            body: "#ffffff",
            button: {
                active: "#30BDEE",
                background: "#30BDEE",
                disabled: "#8b949c",
                disabledText: "#ffffffb5",
                hover: "#299DCB",
                hoverText: "#ffffff",
                text: "#ffffff"
            },
            contrast: "#ffffff",
            disabled: "#8b949c",
            error: "#ff4141",
            gray: "#8b949c",
            highlight: "#227CA8",
            input: {
                active: "#30BDEE",
                background: "#f0f2f4",
                CBBackground: "#8b949c",
                disabled: "#bec5ca",
                disabledText: "#000000e8",
                text: "#000000"
            },
            mobile: {
                active: "#30BDEE",
                background: "#ffffff",
                body: "#ffffff",
                menu: "#ffffff",
                contrast: "#ffffff",
                homeCards: [
                    {
                        card: "#30BDEE",
                        icon: "#ffffff",
                        text: "#FFFFFF"
                    },
                    {
                        card: "#30BDEE",
                        icon: "#ffffff",
                        text: "#FFFFFF"
                    },
                    {
                        card: "#30BDEE",
                        icon: "#ffffff",
                        text: "#FFFFFF"
                    },
                    {
                        card: "#30BDEE",
                        icon: "#ffffff",
                        text: "#FFFFFF"
                    },
                    {
                        card: "#30BDEE",
                        icon: "#ffffff",
                        text: "#FFFFFF"
                    },
                    {
                        card: "#30BDEE",
                        icon: "#ffffff",
                        text: "#FFFFFF"
                    },
                    {
                        card: "#30BDEE",
                        icon: "#ffffff",
                        text: "#FFFFFF"
                    },
                    {
                        card: "#30BDEE",
                        icon: "#ffffff",
                        text: "#FFFFFF"
                    },
                    {
                        card: "#30BDEE",
                        icon: "#ffffff",
                        text: "#FFFFFF"
                    }
                ],
                primary: "#133B62",
                secondary: "#13517a",
                shadow: "#00000027",
                tertiary: "#30BDEE",
                text: "#000000",
                white: "#ffffff",
                loyaltyCard: {
                    background: "#f0f2f4",
                    text: "#000000",
                    bar: "#30BDEE",
                    parentBar: "#bec5ca",
                    barTo: "#30BDEE",
                    car: "#000000",
                    compactBackground: "#66c887",
                    compactText: "#ffffff",
                    compactAccent: "#f6f04f",
                    compactCenter: "#70d194",
                    compactCenterText: "#ffffff"
                }
            },
            modal: {
                body: "#ffffff",
                alert: "#30BDEE",
                promise: "#30BDEE",
                success: "#3fd000",
                warning: "#fccc00",
                error: "#ff4141"
            },
            secondary: "#133B62",
            shadow: "#00000066",
            tertiary: "#30BDEE",
            text: "#000000",
            white: "#ffffff",
            link: "#133B62",
            carouselTitle: "#30BDEE",
            selection: "#c7c7c7"
        }
    },
    companyName: 'Hamilton MFG',
    cardName: 'Gift Card',
    logo: 'https://hamiltonprodcdn.blob.core.windows.net/web/SUB/logo.svg',
    imgParallax: true,
    loyaltyProgram: true,
    giftCardHomeWidget: true,
    airPayName: 'AirPAY',
    homeWidgetText: {
        giftSignedInTitle: 'My App Credit Balance',
        giftGuestTitle: 'App Credit',
        giftGuestMessage: 'SIGN UP TO USE OUR APP CREDIT!',
        loyaltySignedInTitle: 'Reward Progress',
        loyaltyGuestTitle: 'Loyalty Rewards',
        loyaltyGuestMessage: 'SIGN UP TO EARN FREE WASHES!',
        loyaltyGuestSoloMessage: 'SIGN UP TO USE OUR LOYALTY PROGRAM & EARN FREE WASHES!'
    },
    showPWAShadow: true,
    navWords: true,
    homeVideo: 'https://ewash.net/HamiltonCarWash/static/media/bg.490e9365.mp4',
    PWAHomeImage: '',
    carousel: [
        {
            headline: "Buy a Wash",
            text: "",
            tag: "_SHOP",
            href: "_WASHES",
            buttonText: "Shop Now",
            image: "https://ewash.net/HamiltonCarWash/static/media/Carousel3.f5a379a5.png",
            color: "#ffffff",
        },
        {
            headline: "Come Visit Us!",
            text: "",
            tag: "_LOCATIONS",
            href: "",
            buttonText: "Find Us",
            image: "https://ewash.net/HamiltonCarWash/static/media/Carousel2.b34ea1ea.png",
            color: "#ffffff",
        }
    ],
    homeCards: [
        {
            icon: "drop",
            text: "Buy a Wash",
            to: "/washes"
        },
        {
            icon: "barcode",
            text: "Promo Codes",
            to: "/promocode"
        },
        {
            icon: "group",
            text: "Invite a Friend",
            to: "/referral"
        },
        {
            icon: "map",
            text: "Find Us",
            to: "/findUs"
        },
        {
            icon: "mobile",
            text: "AirPAY",
            to: "/airPay"
        }
    ],
    menuItems: [
        {
            label: "Home",
            href: "/",
            tag: "_HOME"
        },
        {
            label: "Shop",
            href: "/shop",
            tag: "_SHOP"
        },
        {
            label: "Locations",
            href: "/locations",
            tag: "_LOCATIONS"
        },
        {
            label: "FAQ",
            href: "/faq",
            tag: "_ABOUT"
        }
    ],
    shopItems: [
        {
            label: "Washes",
            href: "washes",
            tag: "_WASHES"
        },
        {
            label: "",
            href: "washClubs",
            tag: "_CLUBS"
        },
        {
            label: "",
            href: "bundles",
            tag: "_BUNDLES"
        },
        {
            label: "",
            href: "giftCards",
            tag: "_CARDS"
        },
        {
            label: "",
            href: "merch",
            tag: "_MERCH"
        }
    ],
    locations: [],
    googleMap: {
        center: {
            lat: 0,
            lng: 0
        },
        zoom: 11
    },
    bubbles: {
        enabled: false,
        number: 15
    },
    contact: {
        phone: 8005555555
    },
    appStore: {
        apple: '',
        google: ''
    },
    forceLocations: false,
    VAPIDKey: '',
    timeStamp: '1/1/1 00:00:00 AM',
    disabledRoutes: [],
    states: [],
    features: []
}

export const sanitizeSiteConfig = config => {
    let corrected = false;
    const clone = value => JSON.parse(JSON.stringify(value));

    const fillMissing = (def, inc) => {
        if (!def || !inc || typeof def !== 'object' || typeof inc !== 'object') return;

        Object.entries(def).forEach(([key, value]) => {
            if (inc[key] === undefined) {
                inc[key] = clone(value);
                corrected = true;
                return;
            }

            if (
                value &&
                inc[key] &&
                typeof value === 'object' &&
                typeof inc[key] === 'object' &&
                !Array.isArray(value) &&
                !Array.isArray(inc[key])
            ) {
                fillMissing(value, inc[key]);
            }
        });
    }

    const sanitize = (def, inc) => {
        def.forEach((e, i) => {
            if (!inc.find(f => f.tag === e.tag)) {
                inc.splice(i, 0, e);
                console.warn('Missing Shop Item:', e.tag)
                corrected = true;
            }
        });
    }

    fillMissing(defaultSiteConfig, config);
    sanitize(defaultSiteConfig.shopItems, config.shopItems);
    sanitize(defaultSiteConfig.menuItems, config.menuItems);

    return corrected;
}

export const getFirebaseConfig = (env) => {
    switch (env) {
        case 'dev':
            return {
                "apiKey": "AIzaSyDBmElhpVDbA3cVUlPhPSb4F4LIkvY2NTc",
                "appId": "1:582228107343:web:365dee2ea7bbec16d78a3a",
                "authDomain": "hamdev-28bec.firebaseapp.com",
                "measurementId": "G-WQJN9PWGB9",
                "messagingSenderId": "582228107343",
                "projectId": "hamdev-28bec",
                "storageBucket": "hamdev-28bec.appspot.com"
            }
        case 'demo':
            return {
                "apiKey": "AIzaSyDBmElhpVDbA3cVUlPhPSb4F4LIkvY2NTc",
                "appId": "1:582228107343:web:c7bd68c2e7e7ebe1d78a3a",
                "authDomain": "hamdev-28bec.firebaseapp.com",
                "measurementId": "G-K1T949PWC8",
                "messagingSenderId": "582228107343",
                "projectId": "hamdev-28bec",
                "storageBucket": "hamdev-28bec.appspot.com"
            }
        default:
            return {
                "apiKey": "AIzaSyBeBvY1OqC0syvaoKFFFUoSGeHvfiw2pBE",
                "appId": "1:60261949350:web:dd0a0ebf5efcf46546b967",
                "authDomain": "pwa-ecomm.firebaseapp.com",
                "measurementId": "G-1JW5VQW51J",
                "messagingSenderId": "60261949350",
                "projectId": "pwa-ecomm",
                "storageBucket": "pwa-ecomm.appspot.com"
            }
    }
}





// dark: {
//     active: "#61dafb",
//     alert: "#87cfff",
//     body: "#282c34",
//     button: {
//         active: "#b3b3b3",
//         background: "#FAFAFA",
//         disabled: "#494949",
//         disabledText: "#FAFAFA75",
//         hover: "#d9d9d9",
//         hoverText: "#282c34",
//         text: "#282c34"
//     },
//     contrast: "#eeeeee",
//     disabled: "#585858",
//     error: "#f14a4a",
//     gray: "#9c9c9c",
//     highlight: "#60677a",
//     input: {
//         active: "#61dafb",
//         background: "#364054",
//         disabled: "#454950",
//         disabledText: "#ffffffcc",
//         highlight: "#e6e6e6",
//         text: "#FAFAFA"
//     },
//     mobile: {
//         active: "#1f8dff",
//         background: "#282c34",
//         body: "#303541",
//         contrast: "#eeeeee",
//         homeCards: [
//             {
//                 card: "#2ebeef",
//                 icon: "#FFFFFF",
//                 text: "#FFFFFF"
//             },
//             {
//                 card: "#528bb0",
//                 icon: "#FFFFFF",
//                 text: "#FFFFFF"
//             },
//             {
//                 card: "#528bb0",
//                 icon: "#FFFFFF",
//                 text: "#FFFFFF"
//             },
//             {
//                 card: "#22425c",
//                 icon: "#FFFFFF",
//                 text: "#FFFFFF"
//             },
//             {
//                 card: "#0f263d",
//                 icon: "#FFFFFF",
//                 text: "#FFFFFF"
//             },
//             {
//                 card: "#000000",
//                 icon: "#FFFFFF",
//                 text: "#FFFFFF"
//             },
//             {
//                 card: "#000000",
//                 icon: "#FFFFFF",
//                 text: "#FFFFFF"
//             },
//             {
//                 card: "#000000",
//                 icon: "#FFFFFF",
//                 text: "#FFFFFF"
//             }
//         ],
//         loyaltyCard: {
//             background: "#eeeeee",
//             bar: "#ff0000",
//             parentBar: "#cfcfcf",
//             text: "#285981",
//             barTo: "#00ff00",
//             car: "#285981"
//         },
//         primary: "#285981",
//         secondary: "#364054",
//         shadow: "#eeeeee66",
//         tertiary: "#33bfef",
//         text: "#FAFAFA",
//         white: "#eeeeee"
//     },
//     promise: "#24a8ff",
//     secondary: "#364054",
//     shadow: "#eeeeee66",
//     success: "#adff8b",
//     tertiary: "#6177a2",
//     text: "#FAFAFA",
//     warning: "#ffe36c",
//     white: "#eeeeee",
//     link: "#0097ff",
//     carouselTitle: "#6177a2",
//     selection: "#60677a",
// },